module.exports = __webpack_public_path__ + "static/media/track-concierto-de-aranjuez.6348cb1e.png";